<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item  v-for='(item, Key) in JSON.parse(Nav)' :Key='Key'>{{item.name}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>
<script>
    export default {
  name: "crumbs",
  props:{
      Nav: {
        type: String
      }
  },
  data() {
    return {}
  }
}
</script>
